import * as React from "react";
import Component from "../../AbstractComponent";
import Constants from "../../../Action/Constants";
import { connect } from "react-redux";

class Unsubscribe extends Component {
  protected shouldClearBeforeUnmounting: boolean = true;
  protected clearWith: string = Constants.PAGE_CHECK_EMAIL_CLEAR;

  constructor(public props) {
    super(props);
  }

  /**
   * This is the hotfix for react-router issue, that cause the problem of
   * infinite rerendering of component: routeParams(received for react-router Route) props
   * updates few times per sec
   * 
   * TODO: Should be fixed by installing the new version of react-router-dom
   * */ 
   shouldComponentUpdate(newProps, nextState) {
    if (this.state !== nextState) return true;
    const isPropsStringsSame = JSON.stringify(newProps) === JSON.stringify(this.props)
    if (
      isPropsStringsSame
      && newProps.routeParams !== this.props.routeParams
    ) {
      return false;
    }

    return !isPropsStringsSame;
  }

  public componentWillMount() {
    const token = this.props.location?.query?.token;

    this.props.dispatch({
      type: Constants.PAGE_CONTRACT_EMAIL_UNSUBSCRIBE_START,
      payload: {
        token: token
      },
      onSuccess: () => {

      }
    });
  }

  public render() {
    return (
      <div className="state-auth">
        <div className="box component-check-email">
          <h1>Casadesk</h1>
          <p style={{color: "green"}}>{this.trans("unsubcribed-successfully")}</p>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    app: state.app,
    component: state.checkEmail,
    globalTypes: state.globalTypes
  };
};

export default connect(mapStateToProps)(
  Unsubscribe
);
